// import {asElement} from './lib.js'

class Map {
    constructor(element) {
        this.node = asElement(element);
        this.mapLoaded = false;
        this.mapInitialized = false;
        this.coords = [0, 0];
        this.zoom = 15;
    }

    load() {
        if (this.mapLoaded) {return Promise.resolve();}
        this.mapLoaded = true;
        return new Promise((resolve, reject)=> {
            let script = document.createElement('script');
            script.src = '//api-maps.yandex.ru/2.1/?lang=ru_RU&apikey=39acec0d-d7e4-4f4c-9498-8d1dc77526bc';
            script.async = true;
            script.onload = ()=>{
                ymaps.ready(()=>{
                    // this.init();
                    resolve();
                });
            };
            document.body.appendChild(script);
        });
    }

    init() {
        if (this.mapInitialized) return;
        this.mapInitialized = true;
        this.map = new ymaps.Map(this.node, {
            center:   this.coords,
            zoom:     this.zoom,
            controls: ["zoomControl"]
        });
        this.map.behaviors.disable('scrollZoom');
    }
}

class ShopMap {
    constructor(element) {
        this.node = asElement(element);
        this.map = new Map(this.node.querySelector('.map'));
        this.addresses = this.node.querySelector('.addresses');
        this.region = this.node.querySelector('.current_region');
        this.curCity = this.node.querySelector('.current_city');
        this.circle = null;

        let _this = this;

        $(this.addresses).on('click', '.shop_address', function (e) {
            e.preventDefault();
            let coords = this.dataset['coords'].split(',');
            _this.map.map.panTo(coords);
            _this.map.map.setCenter(coords);
            _this.map.map.setZoom(15);

            _this.selectAddress(this.parentNode, coords);
        });

        $(this.curCity).on('change', this.updateCityList.bind(this));
        $(this.region).on('change', (e)=> {
            $(this.curCity).load(`/cities/?region=${this.region.value}`, () => {
                this.curCity.parentNode.hidden = !this.curCity.children.length;
                this.updateCityList();
            });
        });
    }

    init() {
        return this.map.load().then(()=>{
            this.geocode().then((res)=>{
                this.map.coords = res;
                this.map.init();
                // let curCityName = this.curCity.querySelector(`[value="${this.curCity.value}"]`);
                // if (curCityName) {
                    // ymaps.geocode(curCityName.innerHTML).then((res)=> {
                    //     this.map.map.setCenter(res.geoObjects.get(0).geometry.getCoordinates());
                this.fillMarkers();
                this.updateCityList();
                    // });
                // }
            });
        });

    }

    geocode() {
        let location = '';
        if (this.curCity.value) {
            location = this.curCity.querySelector(`[value="${this.curCity.value}"]`).innerHTML;
        } else {
            location = this.region.querySelector(`[value="${this.region.value}"]`).innerHTML;
        }
        return ymaps.geocode(location).then((res)=> {
            return res.geoObjects.get(0).geometry.getCoordinates();
        });
    }

    setMapCenter() {
        return this.geocode().then((res)=>{
            this.map.map.setCenter(res);
        });
    }

    updateCityList() {
        let query = this.curCity.value?`city=${this.curCity.value}`:`region=${this.region.value}`;
        this.setMapCenter().then(()=>{
            $(this.addresses).load(`/shops/?${query}`, ()=> {
                this.fillMarkers();
                //++ обновляем название области или города на карте
                $('#shops-info .current-place').text('');
                var selectedRegionGenitive = $('.current_region option:selected').data('genitive');
                var selectedLocation = $('.current_city option:selected').text();
                var isLocationSelected = $('.current_city option:selected').attr('value');
                if (isLocationSelected) {
                    $('#shops-info .current-place').text('Магазины ' + selectedLocation + ':');
                } else if (selectedRegionGenitive) {
                    $('#shops-info .current-place').text('Магазины ' + selectedRegionGenitive + ':');
                }
                //--
            });
        });
    }

    selectAddress(node, coords) {
        let activeAddresses = this.node.querySelectorAll('.shop_address.active');
        for (let address of activeAddresses) {
            address.classList.remove('active')
        }
        node.querySelectorAll('a')[0].classList.add('active');


        if (this.circle) {
            this.map.map.geoObjects.remove(this.circle);
        }
        this.circle = new ymaps.GeoObject({
            geometry: {
                type:        "Circle",
                coordinates: coords,
                radius:      28
            }
        });
        this.map.map.geoObjects.add(this.circle);
        //this.map.map.setCenter(coords);
    }

    fillMarkers() {
        this.map.map.geoObjects.removeAll();
        let addresses = this.node.querySelectorAll('.shop_address');
        for (let address of addresses) {
            let coord = address.dataset['coords'].split(',');
            let marker = new ymaps.Placemark(coord, {
                shopId: address.dataset['id']
            }, {
                iconLayout:      'default#image',
                iconImageHref:   `/static/yarche_core/images/${address.parentNode.classList.contains('has_bakery') ? 'with' : 'without'}${document.getElementById('map').classList.contains('moscowyarche-map') && address.parentNode.classList.contains('in_lottery') ? '_in_lottery' : ''}.png`,
                iconImageSize:   [14, 14],
                iconImageOffset: [-7, -7]
            });
            this.map.map.geoObjects.add(marker);
            marker.events.add(['click'], (e) => {
                let shopId = e.get('target').properties.get('shopId');
                let shopEntry = this.node.querySelector(`[data-id="${shopId}"]`);
                let shopCoords = shopEntry.dataset['coords'].split(',');
                this.map.map.balloon.open(shopCoords, shopEntry.innerHTML);
                this.selectAddress(shopEntry.parentNode, shopEntry.dataset['coords'].split(','));
            });
        }
        this.map.map.setBounds(this.map.map.geoObjects.getBounds(), {checkZoomRange: false});
    }
}
